import { ThrowStmt } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { encryptStorage } from 'src/app/auth/utils/storage';
import { generateUUID } from 'src/app/shared/utils/functions/codigo-transacao.model';
import { showDefaultError, showError, showSucess } from 'src/app/shared/utils/functions/notification.function';
import { safeAsign } from 'src/app/shared/utils/functions/safe-asign.function';
import Swal from 'sweetalert2';
import { BancoService } from '../../services/banco.service';
import { SolicitarGarantiaService } from '../../services/solicitar-garantia.service';

@Component({
  selector: 'app-modal-editar-dados',
  templateUrl: './modal-editar-dados.component.html',
  styleUrls: ['./modal-editar-dados.component.scss']
})
export class ModalEditarDadosComponent implements OnInit {

  formDadosBancarios: FormGroup
  tipoPessoa: string = ''

  tableBancos: any[] = []
  garantiaOrdinaria: boolean

  idInvestidor: any

  constructor(
    private bancoService: BancoService,
    private garantiasService: SolicitarGarantiaService,
    private modalRef: MDBModalRef) { }

  ngOnInit(): void {
    this.tipoPessoa = encryptStorage.getItem('@tipoPessoa', false)
    this.listarBancos()
    this.createFormDados('')
  }

  createFormDados(banco){
    this.formDadosBancarios = new FormGroup({
      idInvestidor: new FormControl(this.idInvestidor),
      bancoId: new FormControl(banco.codigoBanco, [Validators.required]),
      tpConta: new FormControl(banco.tipoConta, [Validators.required]),
      agencia: new FormControl(banco.agencia, [Validators.required]),
      dgAgencia: new FormControl(banco.dgAgencia),
      conta: new FormControl(banco.conta, [Validators.required]),
      dgConta: new FormControl(banco.digitoConta, [Validators.required])
    })
  }

  onBancoChange(banco: string): void {
    if (banco !== '001') {
      this.formDadosBancarios.get('dgAgencia')?.reset();
    }
  }

  listarBancos() {
    this.bancoService.listarBancos().subscribe(
      res => this.tableBancos = res["data"]["bancos"],
      e => console.log
    )
  }

  updateDados(){
    let bancoNome = ''

    if(this.banco.value == '001'){
      if(!safeAsign(this.digitoAgencia)){
        return showError('Dígito Agência não informado', 'o campo Dígito Agência é obrigatório para o banco selecionado.')
      }
    }

    this.tableBancos.forEach(banco => {
      if(banco.id == this.banco.value){
        bancoNome= banco.nome
      }
    })

    const digitoAgencia = this.banco.value === '001'
      ? `Dígito Agência: ${this.digitoAgencia.value}`
      : '';

    let confirmarDados = `Por gentileza,
    confirme se os dados bancários
    fornecidos, estão corretos:
    <div class="mt-3" style="display: flex; flex-direction: column; align-items: center; gap: 6px;">
      <div style="display: flex; gap:6px;">
        <span >Banco:</span>
        <span >${bancoNome}</span>
      </div>
      <div style="display: flex; gap:6px;">
        <span >Tipo Conta:</span>
        <span >${this.tipoConta.value}</span>
      </div>
      <div style="display: flex; gap:6px;">
        <span >Agência:</span>
        <span >${this.agencia.value}</span>
      </div>
      ${digitoAgencia}
      <div style="display: flex; gap:6px;">
        <span >Conta:</span>
        <span >${this.conta.value}</span>
      </div>
      <div style="display: flex; gap:6px;">
        <span >Dígito Conta:</span>
        <span >${this.digitoConta.value}</span>
      </div>
    </div>
    `

    Swal.fire({
      title: 'Dados Bancários',
      html: confirmarDados,
      padding: '3rem',
      width: '700px',
      showConfirmButton: true,
      showDenyButton: true,
      confirmButtonText: 'Confirmar',
      denyButtonText: 'Corrigir',
      confirmButtonColor: '#3085d6',
      denyButtonColor: '#d33'
    }).then(result => {
      if(result.isConfirmed){
        if(this.tipoPessoa == 'ENTIDADE'){
          if(this.formDadosBancarios.invalid){
            return showError('Campos Obrigatórios', 'Campos Obrigatórios não informados.')
          }else{
            let body = {
              codigoTransacao: generateUUID(),
              data: this.formDadosBancarios.value
            }
            this.garantiasService.alterarDadosEntidade(body).subscribe(
              res => {
                this.closeModal()
                showSucess('Sucesso', 'Sucesso ao alterar os dados bancários')
              },e => showDefaultError(e))
          }
        }else {
          if(this.garantiaOrdinaria){
            if(this.formDadosBancarios.invalid){
              return showError('Campos Obrigatórios', 'Campos Obrigatórios não informados.')
            }else{
              let body = {
                codigoTransacao: generateUUID(),
                data: {
                  idInvestidor: this.idInvestidor,
                  bancoId: this.banco.value,
                  tipoConta: this.tipoConta.value,
                  agencia: this.agencia.value,
                  digitoAgencia: this.digitoAgencia.value,
                  conta: this.conta.value,
                  digitoConta: this.digitoConta.value
                }
              }
              this.garantiasService.alterarDadosInvestidorOrdinaria(body).subscribe(
                res => {
                  this.closeModal()
                  showSucess('Sucesso', 'Sucesso ao alterar os dados bancários')
                },e => showDefaultError(e))
            }
          }else{
          if(this.formDadosBancarios.invalid){
            return showError('Campos Obrigatórios', 'Campos Obrigatórios não informados.')
          }else{
            let body = {
              codigoTransacao: generateUUID(),
              data: this.formDadosBancarios.value
            }
            this.garantiasService.alterarDadosInvestidor(body).subscribe(
              res => {
                this.closeModal()
                showSucess('Sucesso', 'Sucesso ao alterar os dados bancários')
              },e => showDefaultError(e))
          }

        }
      }
      }else if(result.isDenied){
        return
      }
    })


  }

  validateDataBank(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/^(\d*[a-zA-Z]?\d*).*$/, '$1').replace(/[^0-9a-zA-Z]/g, '');
  }

  closeModal(){
    return this.modalRef.hide()
  }





  get banco(){
    return this.formDadosBancarios.get('bancoId')
  }

  get tipoConta(){
    return this.formDadosBancarios.get('tpConta')
  }
  get agencia(){
    return this.formDadosBancarios.get('agencia')
  }

  get digitoAgencia(){
    return this.formDadosBancarios.get('dgAgencia')
  }
  get conta(){
    return this.formDadosBancarios.get('conta')
  }

  get digitoConta(){
    return this.formDadosBancarios.get('dgConta')
  }
}
